import { TemplateId } from './TemplateRegistry';

export interface ShareReviewState {
    selectedTemplate: TemplateId;
    reviewerName: string;
    reviewText: string;
    rating: string;
    network: string;
    color: string;
    showLogo: boolean;
    showSource: boolean;
}

export interface ReviewTemplateProps {
    reviewerName: string;
    reviewText: string;
    rating: string;
    network: string;
    color: string;
    logo: string | undefined;
    showLogo: boolean;
    showSource: boolean;
}

export const DEFAULT_COLORS = [
    { name: 'Bleu', value: '#3B82F6' },
    { name: 'Vert', value: '#10B981' },
    { name: 'Violet', value: '#8B5CF6' },
    { name: 'Orange', value: '#F59E0B' },
    { name: 'Rose', value: '#EC4899' },
    { name: 'Gris', value: '#6B7280' },
];

export const MAX_TEXT_LENGTH = 150;
